export const LMS_COURSES_RESET_STATE = 'LMS_COURSES_RESET_STATE';
export const LMS_COURSES_CURRENT_ITEM = 'LMS_COURSES_CURRENT_ITEM';

export const LMS_COURSES_REQUEST_LOADING = 'LMS_COURSES_REQUEST_LOADING';
export const LMS_COURSES_REQUEST_SUCCESS = 'LMS_COURSES_REQUEST_SUCCESS';
export const LMS_COURSES_REQUEST_FAILED = 'LMS_COURSES_REQUEST_FAILED';

export const LMS_COURSES_CURRENT_ACTION = 'LMS_COURSES_CURRENT_ACTION';
export const LMS_COURSES_RESET_ACTION = 'LMS_COURSES_RESET_ACTION';
